import Link from 'next/link';

import * as React from 'react';

import type { ILinkData, ILinkSectionData, ISubSections } from '@/shared/actions/navigation.service';

export interface IMobileServiceMenuProps {
    serviceMenu: (ILinkData | ILinkSectionData)[];
    setSubsectionSelected: React.Dispatch<React.SetStateAction<ISubSections | null>>;
}

export function MobileServiceMenu({ serviceMenu, setSubsectionSelected }: IMobileServiceMenuProps) {
    return (
        <div className='flex w-full flex-col items-center justify-center'>
            {serviceMenu.map(serviceMenu => (
                <div
                    className='text-menu-secondary text-subtle w-full cursor-pointer py-3 text-center'
                    key={serviceMenu.id}>
                    {'isLinkSection' in serviceMenu ? (
                        <div onClick={() => setSubsectionSelected(serviceMenu)}>{serviceMenu.title}</div>
                    ) : (
                        <Link href={serviceMenu.internalLink || serviceMenu.url || '#'}>{serviceMenu.title}</Link>
                    )}
                </div>
            ))}
        </div>
    );
}
